<script lang="ts">
  import { Addon } from '$lib/components/ui/input-group';
  import InputGroupInput from '$lib/components/ui/input-group/input-group-input.svelte';
  import InputGroup from '$lib/components/ui/input-group/input-group.svelte';
  import { SearchIcon } from 'lucide-svelte';

  let {
    q = $bindable(''),
    onInput,
  }: {
    q: string;
    onInput?: any;
  } = $props();
</script>

<InputGroup
  class="!px-4 !h-12 border border-slate-200 bg-white text-slate-900 shadow-none
    dark:border-gray-600 dark:bg-[var(--theme-canvas)] dark:text-[var(--theme-font)]
    !outline-none focus:!outline-none focus-visible:!outline-none
    focus:ring-0 focus-visible:ring-0 !ring-0
    !shadow-none focus:!shadow-none focus-visible:!shadow-none"
>
  <InputGroupInput
    type="search"
    placeholder="Search…"
    bind:value={q}
    oninput={(e) => {
      if (!onInput) return;
      onInput(e);
    }}
    class="!h-12 !border-none !rounded-sm !focus:outline-none
      text-slate-900 placeholder:text-slate-500
      dark:!bg-transparent dark:text-[var(--theme-font)]
      dark:placeholder:text-[var(--theme-font-alt)]/80"
    style={`padding: 8px 12px; width: 100%;  border-radius: 0px;`}
  />
  <Addon align="inline-end" class="!pr-2 text-slate-500 dark:text-[var(--theme-font-alt)]">
    <SearchIcon class="size-4 shrink-0" aria-hidden="true" />
  </Addon>
</InputGroup>
